import { memo } from 'react';
import { cn } from '@divlab/divanui';

import styles from './VideoIframe.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface VideoIframeProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  src: string;
  title?: string;
}

const VideoIframe: FC<VideoIframeProps> = (props) => {
  const { className, src, title, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.container, className)}>
      <iframe
        src={src}
        title={title}
        allow='autoplay; fullscreen; picture-in-picture; encrypted-media;'
        allowFullScreen
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          border: 'none',
        }}
      />
    </div>
  );
};

export default memo(VideoIframe);
